// Referral code capture (card 202).
//
// The invite link is `/auth/register?ref=CODE`, but people do not sign up the
// instant they click. They land, read the marketing pages, close the tab, come
// back tomorrow. So the code is captured from the URL on first load and STASHED,
// then read again whenever registration actually happens.
//
// localStorage rather than a cookie: this is first-party, it is not sent to any
// server on its own, and the app already clears localStorage on logout.

const STORAGE_KEY = 'resiview.referralCode';

// Same shape the backend accepts — see use-cases/referrals.js. Sanitizing here
// too keeps junk out of storage rather than discovering it at signup.
const normalize = (value) =>
  String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 16);

// Call once on app boot. Safe to call repeatedly; a later visit WITHOUT a code
// never clears an earlier one, so browsing around after clicking the invite does
// not lose the attribution.
export function captureReferralCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = normalize(params.get('ref'));
    if (code) window.localStorage.setItem(STORAGE_KEY, code);
  } catch (err) {
    // Private-browsing modes can throw on localStorage. A missed referral is
    // not worth breaking app startup over.
  }
}

export function readReferralCode() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || '';
  } catch (err) {
    return '';
  }
}

export function clearReferralCode() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    // Nothing to do — see above.
  }
}
